import moment from "moment";

export function validateEmail(email: string) {
  if (!email) {
    return false;
  }
  const regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexp.test(email);
}

export function validatePhoneNumber(phoneNumber: string) {
  if (!phoneNumber) {
    return false;
  }
  const numberWithoutWhitespace = phoneNumber.replace(/ /g, '');
  const regexp = /^((0047)?|(\+47)?|(47)?)(\d{8})$/;
  const valid = regexp.test(numberWithoutWhitespace);
  if (valid) {
    const firstChar = numberWithoutWhitespace
      .substr(numberWithoutWhitespace.length - 8)
      .charAt(0);
    return firstChar === '9' || firstChar === '4'; // All mobile numbers starts with 4 og 9
  }
  return false;
}

export function validatePhoneNumberStartsCorrectly(phoneNumber: string) {
  if (!phoneNumber) {
    return true;
  }
  const numberWithoutWhitespace = phoneNumber.replace(/ /g, '');
  const regexp = /(^0047|^\+47|^47|^\+$|^\+4$|^0$|^00$|^004$|^4|^9)/;
  return regexp.test(numberWithoutWhitespace);
}

export function validateCode(code: string) {
  if (!code) {
    return false;
  }
  const regexp = /^(([0-9]){4})$/;
  return regexp.test(code);
}

export function validateCompanyName(name?: string) {
  if (!name) {
    return false;
  }
  return name.trim().length > 1;
}

export function validateAtLeastOneCharacter(name?: string) {
  if (!name) {
    return false;
  }
  return name.trim().length > 0;
}

export function validateName(name?: string) {
  if (!name || name === '') {
    return false;
  }
  return (
    /^[a-zA-Z0-9\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF-_ ]{1,46}$/.test(
      name
    ) &&
    !/[-_]$/.test(name) &&
    !/[-_ ]{2,}/.test(name) &&
    name.trim().length > 0
  );
}

export function zipDeliverable(zipCode?: string, validZipCodes?: number[]) {
  const zipCodes = !validZipCodes ? [] : validZipCodes;
  return (
    zipCode === undefined ||
    zipCode.length < 4 ||
    zipCodes.length === 0 ||
    zipCodes.indexOf(Number(zipCode)) !== -1
  );
}

export function validateZipCode(zipCode?: string, validZipCodes?: number[]) {
  const regexp = /^([0-9]{4})$/;
  if(!zipCode){
    return false;
  }
  return regexp.test(zipCode) && zipDeliverable(zipCode, validZipCodes);
}

export function validateZipCodeStartsCorrectly(zipCode?: any) {
  if (!zipCode) {
    return true;
  }
  if (zipCode.length > 4) {
    return false;
  }
  if (isNaN(zipCode)) {
    return false;
  }
  return true;
}

export function validateCity(city: string) {
  if (!city) {
    return false;
  }
  return city.length > 0;
}

export function validate18YearsOld(
  day: number | string,
  month: number | string,
  year: number | string
) {
  const birthDay = moment(`${year}-${`${+month + 1}`.padStart(2, '0')}-${`${day}`.padStart(2, '0')}`);
  const validDate = birthDay.isValid();
  const atLeast18YearsAgo = birthDay.isSameOrBefore(moment().subtract(18, 'years'), 'days');
  return validDate && atLeast18YearsAgo;
}

export function validateOrgnumber(orgNumber: string) {
  if (!orgNumber || orgNumber.length !== 9) {
    return false;
  }
  return (
    parseInt(orgNumber.charAt(orgNumber.length - 1), 10) ===
    mod11OfNumberWithControlDigit(orgNumber)
  );
}

export function mod11OfNumberWithControlDigit(input: any) {
  let controlNumber = 2;
  let sumForMod = 0;
  for (let i = input.length - 2; i >= 0; --i) {
    sumForMod += input.charAt(i) * controlNumber;
    if (++controlNumber > 7) {
      controlNumber = 2;
    }
  }
  const result = 11 - (sumForMod % 11);
  return result === 11 ? 0 : result;
}
